import { Attributes } from '@growthbook/growthbook-react'
import { MeQuery } from 'types/graphql'

export const getInitialAttributes = ({ user, segmentTrackingId }: { user?: MeQuery['me'] | null; segmentTrackingId: string }): Attributes => {
  if (user) {
    return {
      id: segmentTrackingId,
      loggedIn: true,
      level: user.level,
      reviewCount: user.reviewCount,
      betaTester: user.betaTester
    }
  } else {
    return {
      id: segmentTrackingId,
      loggedIn: false,
      level: null,
      reviewCount: null,
      betaTester: false
    }
  }
}
